import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import apiService from '../../services/api.service';
import { useNavigate } from 'react-router-dom';

type Props = {
  prId?: number;
  poId?: number;
  docId?: number;
  docType?: 'PR' | 'PO';
  onClick?: () => void;
  onAfterAction?: () => void;
  title?: string;
  size?: 'small' | 'medium' | 'large';
};

const GoldenArrow: React.FC<Props> = ({ prId, poId, docId, docType, onClick, onAfterAction, title = 'Open', size = 'small' }) => {
  const navigate = useNavigate();

  const handleClick = async () => {
    if (onClick) {
      onClick();
      return;
    }
    const type = String(docType || (poId ? 'PO' : 'PR')).toUpperCase();
    const resolvedPoId = Number(poId || (type === 'PO' ? docId : 0) || 0);
    const resolvedPrId = Number(prId || (type === 'PR' ? docId : 0) || 0);

    if (type === 'PO' && resolvedPoId > 0) {
      navigate(`/po/${resolvedPoId}`);
      return;
    }
    if (resolvedPrId <= 0) return;
    try {
      const r = await apiService.getPR(Number(resolvedPrId));
      const d = (r as any)?.data || r || {};
      navigate(`/pr/${resolvedPrId}`, { state: { pr: d } });
    } catch {
      navigate(`/pr/${resolvedPrId}`);
    }
  };

  void onAfterAction;

  return (
    <>
      <Tooltip title={title}>
        <IconButton
          size={size}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            (e.currentTarget as HTMLElement).blur();
            void handleClick();
          }}
          aria-label={title}
          sx={{
            p: 0,
            background: 'transparent',
            boxShadow: 'none',
            '&:hover': { background: 'transparent' }
          }}
        >
          <SvgIcon sx={{ fontSize: 20, filter: 'drop-shadow(0 1px 1px rgba(0,0,0,0.25))' }} viewBox="0 0 24 24">
            <rect x="4" y="9" width="9" height="6" fill="#F7D14A" />
            <polygon points="13,6 22,12 13,18" fill="#F7D14A" />
          </SvgIcon>
        </IconButton>
      </Tooltip>
    </>
  );
};

export default GoldenArrow;
